<h4>GoArmy Edge is multi-platform and will run on all your devices.</h4>

<img class="platforms" src="/assets/images/platforms.svg" alt="GoArmyEdge Platforms">

<div class="launch-buttons">
  <img class="apple" src="/assets/images/icon-appstore.svg" alt="Download on the App Store">
  <img class="play" src="/assets/images/icon-playstore.svg" alt="Get it on Google Play">
  <img class="windows" src="/assets/images/icon-windowsstore.svg" alt="Get it from Microsoft">
  <img class="webplayer" src="/assets/images/icon-webplayer.svg" alt="Use the Web Player">
</div>
